export default __webpack_public_path__ + "static/media/mail.637c1a38.svg";